import { Http } from "./http";
import fileSaver from 'file-saver';

export class BasicService {

  static http = new Http();

  /**
   *
   * @param {File | Blob} upfile
   * @param {'goods' | 'article' | 'certificates'} path_type
   * @param {String} action
   */
  static upload(upfile, path_type = '', action = 'uploadimage') {
    return this.http.upload(
      `/File_logic/upload?path_type=${path_type}&action=${action}`,
      { upfile });
  }

  static uploadForUrl(file, path_type) {
    return this.upload(file, path_type).then(data => {
      return data.url;
    })
  }

  static spliceImg(imgStr = '') {
    const url = 'https://api.goodyiyao.cn/';
    // const url2 = 'http://api.goodyiyao.cn/';
    // return url + imgStr.replace(imgStr.match(/^[http|https]/) ? url : url2, '');
    return imgStr.match(/^http|https/) ? imgStr : (url + imgStr);
  }

  static eliminateImg(imgUrl = '') {
    const url = 'https://api.goodyiyao.cn/';
    return imgUrl.replace(url, '');
  }

  static download(url = '') {
    const [ name ] = url.match(/([^/]+\.[a-zA-Z0-9]+)$/);
    fileSaver.saveAs(url, name);
  }

  static async extractImg(data, field, isArray = false, path_type = 'goods') {
    const url = 'https://api.goodyiyao.cn/';
    if (data[field].length > 1 || isArray) {
      const files = [];
      for (let i = 0; i < data[field].length; i++) {
        if (data[field][i].name === '图片异常') {
          files.push(data[field][i].url.replace(url, ''));
        } else {
          const img = await this.upload(data[field][i].originFileObj, path_type);
          files.push(img.sub_path);
        }
      }
      data[field] = files;
      return;
    }
    if (data[field][0].name === '图片异常') {
      data[field] = data[field][0].url.replace(url, '');
    } else {
      const img = await this.upload(data[field][0].originFileObj, 'goods');
      data[field] = img.sub_path;
    }
  }

  static searchTreeParent(treeData = [], id) {
    if (treeData && treeData.length) {
      for (let i = 0; i < treeData.length; i++) {
        if (treeData[i].id === id) {
          return [ id ];
        }
        const found = this.searchTreeParent(treeData[i].sub, id);
        if (found) {
          found.unshift(treeData[i].id);
          return found;
        }
      }
    }
  }

}
